import React from 'react'
import { Btn, CustomDataTableHeader } from '../../../../../../components'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { gerarArquivoExcel } from '../../../../../../services/util/excel.service'
import { formatDateToLocale } from '../../../../../../services/util/date.service'
import '../../../../Picking/HistoricoLeitura/TabHistorico.css'

const EXCEL_COLUMNS = [
  { header: 'Horário', get: b => b.horario },
  { header: 'Produto', get: b => b.produto },
  { header: 'Vol', get: b => b.vol },
  { header: 'Uni', get: b => b.uni },
  { header: 'Estoque', get: b => b.estoque },
  { header: 'Posição', get: b => b.posicao },
  { header: 'Usuário', get: b => b.usuario_name },
  { header: 'Lote', get: b => b.lote },
  { header: 'Validade', get: b => b.validade },
]

const TabHistoricoExpedicao = ({ bips, excelFileName = 'historico_conferencia_expedicao.xlsx' }) => {
  const [globalFilter, setGlobalFilter] = React.useState('')
  // Render
  return (
    <div className="p-grid p-col-12">
      <div className="p-col-12">
        <Btn
          onClick={() => {
            const data = [EXCEL_COLUMNS.map(c => c.header)]
            bips.forEach(b => {
              data.push(EXCEL_COLUMNS.map(c => c.get(b)))
            })
            gerarArquivoExcel('Histórico', data, excelFileName)
          }}
        >
          Exportar
        </Btn>
      </div>
      <div className="p-col-12 p-datatable-responsive">
        <DataTable
          value={bips}
          emptyMessage={'Não existe Histórico de Leitura/Bip'}
          header={
            <div style={{ width: '100%', height: 50 }}>
              <CustomDataTableHeader onChange={setGlobalFilter} />
            </div>
          }
          globalFilter={globalFilter}
          rows={15}
          paginator={true}
          responsive={true}
        >
          <Column
            field={'horario'}
            header={'Horário'}
            className="column-responsive"
            style={{ width: '140px' }}
            body={h => {
              if (h.horario && h.horario !== '-') {
                try {
                  return formatDateToLocale(h.horario, 'dd/MM/yy HH:mm:ss').toFormat(
                    'dd/MM/yy HH:mm:ss',
                  )
                } catch (e) {
                  return '-'
                }
              }
              return '-'
            }}
          />
          <Column
            field={'produto'}
            header={'Produto'}
            className="column-responsive column-important"
          />
          <Column field={'vol'} header={'Vol'} className="column-number" style={{ width: '80px' }} />
          <Column field={'uni'} header={'Uni'} className="column-number" style={{ width: '80px' }} />
          <Column
            field={'estoque'}
            header={'Estoque'}
            className="column-responsive"
            style={{ width: '120px' }}
          />
          <Column
            field={'posicao'}
            header={'Posição'}
            className="column-responsive"
            style={{ width: '120px' }}
          />
          <Column field={'usuario_name'} header={'Usuário'} className="column-responsive md-hide" />
          <Column
            field={'lote'}
            header={'Lote'}
            className="column-responsive"
            style={{ width: '100px' }}
          />
          <Column
            field={'validade'}
            header={'Validade'}
            className="column-responsive"
            style={{ width: '100px' }}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default TabHistoricoExpedicao
